import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-479b1ad2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice-container" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "form-wrap" }
const _hoisted_4 = { class: "default-wrap" }
const _hoisted_5 = { class: "footer xag-page__footer" }
const _hoisted_6 = { class: "content" }

import AppHeader from '@/components/Header.vue'
import FormItemWrap from './components/form-item-wrap.vue'
import getRoute from '@/compositions/route'
import { reactive, computed, ComputedRef, ref, Ref } from 'vue'
import { useRouter, Router } from 'vue-router'
import { InvoiceItem, formatInvoiceItem, saveInvoiceParameter } from '@/types/invoice'
import { getInvoiceCompanyList, getInvoiceCreditDetail, saveInvoice } from '@/apis/invoice'
import {
  invoiceTypeColorMap,
  invoiceTypeTextMap,
  invoiceListStorageKey,
  addressListStorageKey,
  invoiceEditItemStorageKey,
  cacheFromStorageKey,
} from './definition'
import { Button, RadioGroup, Radio, Field, Checkbox, CellGroup, Cell, Toast } from 'vant'
import {
  showConfirmModal,
  debouce,
  showToastLoading,
  clearToast,
  showToastFail,
  showToastSuccess,
} from '@/utils/tools'
import { validateIDCard } from '@/utils/index'


export default /*#__PURE__*/_defineComponent({
  __name: 'edit',
  setup(__props) {

/* eslint-disable @typescript-eslint/no-unused-vars */
const components = {
  AppHeader,
  FormItemWrap,
  Field,
}
const { query: routerQuery } = getRoute()
const $router: Router = useRouter()
let guid = (routerQuery.value.guid as string) || ''
let cacheData: formatInvoiceItem = {} as formatInvoiceItem
if (guid) {
  const storageStr = sessionStorage.getItem(invoiceEditItemStorageKey)
  if (storageStr) {
    cacheData = JSON.parse(storageStr)
    console.log('cacheData', cacheData)
    if (!cacheData.type && cacheData.bill_type) {
      cacheData.type = cacheData.bill_type === 2 ? 'company' : 'personal'
    }
  } else {
    cacheData = {} as formatInvoiceItem
  }
}
const headerTitle = (guid ? '编辑' : '新增') + '发票抬头'
const form = reactive({
  invoice_type: cacheData.invoice_type || 0,
  type: cacheData.type || 'company',
  header: cacheData.header || '',
  header1: cacheData.header || '个人',
  taxpayer_no: cacheData.taxpayer_no || '',
  company_address: cacheData.company_address || '',
  company_phone: cacheData.company_phone || '',
  bank_name: cacheData.bank_name || '',
  bank_account: cacheData.bank_account || '',
  default: cacheData.default || false,
})
const companyOptions: Ref<string[]> = ref([])
const isElectronicNormalInvoice: ComputedRef<boolean> = computed(() => {
  let invoice_type = form.invoice_type
  return invoice_type === 0
})
const isVatSpecialInvoice: ComputedRef<boolean> = computed(() => {
  let invoice_type = form.invoice_type
  return invoice_type === 1
})
const isCompanyInvoice: ComputedRef<boolean> = computed(() => {
  let type = form.type
  return type === 'company'
})
const isPersonalInvoice: ComputedRef<boolean> = computed(() => {
  let type = form.type
  return type === 'personal'
})
const isFromNewInvoiceVersion = computed(() => {
  return !!sessionStorage.getItem(cacheFromStorageKey)
})
async function checkInvoiceTaxpayerNo(name: string) {
  // 获取对应的税号
  showToastLoading()
  try {
    let data = await getInvoiceCreditDetail({ name })
    form.taxpayer_no = data.creditNo
  } catch (error) {
    console.log('error', error)
  }
  clearToast()
}
function cellClick(item: string) {
  console.log(item)
  form.header = item
  companyOptions.value = []
  checkInvoiceTaxpayerNo(form.header)
}
function invoiceTypeChange() {
  let invoice_type = form.invoice_type
  if (invoice_type === 1) {
    form.type = 'company'
  }
}
const getCompanyList = debouce(async () => {
  const keyword = form.header
  if (!keyword) {
    return
  }
  try {
    let data = await getInvoiceCompanyList({ keyword })
    companyOptions.value = data.slice(0, 6)
  } catch (error) {
    console.log('error', error)
  }
}, 400)
function getSaveParameter() {
  // 获取参数
  const parameter: saveInvoiceParameter = {
    header: isPersonalInvoice.value ? form.header1 : form.header,
    type: form.type,
    invoice_type: form.invoice_type,
    default: form.default,
    taxpayer_no: form.taxpayer_no,
    company_phone: form.company_phone,
  }
  parameter.guid = guid
  if (isCompanyInvoice.value) {
    // 如果是公司的抬头类型
    parameter.taxpayer_no = form.taxpayer_no
    parameter.company_address = form.company_address
    // parameter.company_phone = form.company_phone
    parameter.bank_name = form.bank_name
    parameter.bank_account = form.bank_account
  }
  parameter.default = form.default
  return parameter
}
function verifyParameter(parameter: saveInvoiceParameter) {
  let message = ''
  if (isPersonalInvoice.value) {
    if (!parameter.header) {
      message = '请输入个人姓名'
    } else if (parameter.taxpayer_no && !validateIDCard(parameter.taxpayer_no)) {
      message = '请输入正确格式的身份证号'
    }
  } else if (isCompanyInvoice.value) {
    if (!parameter.header) {
      message = '请输入公司名称'
    } else if (!parameter.taxpayer_no) {
      message = '请输入纳税人识别号'
    }
  }
  if (message) {
    Toast(message)
    return false
  }
  return true
}
async function saveInvoiceHandle() {
  const parameter = getSaveParameter()
  if (!verifyParameter(parameter)) {
    return
  }
  console.log('parameter', parameter)
  try {
    await showConfirmModal({
      title: '是否确认保存？',
    })
    showToastLoading()
    await saveInvoice(parameter)
    showToastSuccess('保存成功')
    sessionStorage.removeItem(invoiceListStorageKey) // 删除的缓存，以便更新
    setTimeout(() => {
      $router.go(-1)
    }, 500)
  } catch (e) {
    if (!e) {
      return
    }
    let message = e && e.message
    showToastFail(message)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, { title: headerTitle }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(FormItemWrap, { label: "发票类型" }, {
          default: _withCtx(() => [
            _createVNode(_unref(RadioGroup), {
              modelValue: form.invoice_type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.invoice_type) = $event)),
              "checked-color": "#00B359",
              class: "radio-group",
              onChange: invoiceTypeChange
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Radio), { name: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(isFromNewInvoiceVersion) ? '' : '电子') + "普通发票", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Radio), { name: 1 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(isFromNewInvoiceVersion) ? '' : '增值税') + "专用发票", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_unref(isElectronicNormalInvoice))
          ? (_openBlock(), _createBlock(FormItemWrap, {
              key: 0,
              label: "抬头类型"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(RadioGroup), {
                  modelValue: form.type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.type) = $event)),
                  "checked-color": "#00B359",
                  class: "radio-group"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Radio), { name: "company" }, {
                      default: _withCtx(() => [
                        _createTextVNode("公司")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Radio), { name: "personal" }, {
                      default: _withCtx(() => [
                        _createTextVNode("个人")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isCompanyInvoice))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(FormItemWrap, {
                label: "公司名称",
                require: "",
                style: {"poistion":"relative"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Field), {
                    modelValue: form.header,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.header) = $event)),
                    class: "input-class",
                    placeholder: "公司名称",
                    onInput: _unref(getCompanyList)
                  }, null, 8, ["modelValue", "onInput"])
                ]),
                _: 1
              }),
              (companyOptions.value.length > 0)
                ? (_openBlock(), _createBlock(_unref(CellGroup), {
                    key: 0,
                    class: "company-list"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyOptions.value, (item, index) => {
                        return (_openBlock(), _createBlock(_unref(Cell), {
                          key: item + index,
                          onClick: ($event: any) => (cellClick(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(FormItemWrap, {
                label: "税号",
                require: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Field), {
                    modelValue: form.taxpayer_no,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.taxpayer_no) = $event)),
                    class: "input-class",
                    placeholder: "纳税人识别号"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        (_unref(isPersonalInvoice))
          ? (_openBlock(), _createBlock(FormItemWrap, {
              key: 2,
              label: "发票抬头",
              require: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Field), {
                  modelValue: form.header1,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.header1) = $event)),
                  class: "input-class",
                  placeholder: "姓名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Checkbox), {
          modelValue: form.default,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.default) = $event)),
          shape: "square",
          "icon-size": "16px",
          "checked-color": "#00B359"
        }, {
          default: _withCtx(() => [
            _createTextVNode("设为默认")
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(Button), {
          block: "",
          class: "confirm-button",
          onClick: saveInvoiceHandle
        }, {
          default: _withCtx(() => [
            _createTextVNode("保存并使用")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})